<template>
    <div id="orderpage">
        <div class="top-buttons">
            <ui5-button
                v-if="hasRight('administration')"
                @click="editOrderClick"
            >
                {{ trans('pages.order.edit') }}
            </ui5-button>
        </div>
        <spinner-text v-if="loading">
            {{ trans('pages.order.fetching_order') }}
        </spinner-text>
        <ui5-list v-if="products">
            <UI5-li
                v-for="product in products"
                @click="$router.push('/productpage/' + product.productId)"
                :key="'product.' + product.productId"
            >
                {{ product.productNr }}, {{ product.producttypeName }}
                {{ product.name }} - {{ product.reference }},
                {{ product.productstatus }}
            </UI5-li>
        </ui5-list>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import { mapGetters } from 'vuex';
import productApi from '../api/product';
import IdParamMixin from '../mixins/id-param';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    components: { SpinnerText },
    data() {
        return {
            loading: false,
            products: null,
        };
    },
    mounted() {
        this.load();
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
    },
    methods: {
        load() {
            this.$store.commit(
                'general/setPageTitle',
                `${this.trans('pages.order.title_prefix')} ${this.idParam}`
            );
            this.loading = true;
            productApi
                .productsForOrderV2(this.idParam)
                .then((response) => {
                    this.products = response.data.data.products;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        editOrderClick() {
            this.$store.commit('general/setOrderId', this.idParam, {
                root: true,
            });
            this.$router.push('/editproduct/?orderId=' + this.idParam);
        },
    },
};
</script>
